import React, { useState } from 'react';
import cn from 'classnames';
import { InputField } from '@trp-innersource/react-controls';
import styles from './WatchlistRename.css';

import { renameWatchlist } from '../../Hooks/useWatchlist';

const WatchlistRename = ({
    closeModal = () => {},
    watchlistUuid: selectedWatchlistUuid = '',
    watchlistName: selectedWatchlistName = ''
}) => {
    const [name, setName] = useState(selectedWatchlistName);
    const [disabled, setDisabled] = useState(
        selectedWatchlistName.length === 0
    );
    const doRename = renameWatchlist(selectedWatchlistUuid, name);

    const isValidName = (nameToVerify) => {
        const nameRegex = new RegExp(/^[a-zA-Z0-9\s]+$/);
        setDisabled(true);
        setName(nameToVerify);
        if (!nameToVerify || nameToVerify.trim() === '')
            return 'This field is required';
        if (!nameRegex.test(nameToVerify)) {
            return `Special Characters are not allowed`;
        }
        setDisabled(false);
        return null;
    };

    const saveName = () => {
        if (!isValidName(name)) {
            doRename();
            closeModal();
        }
    };

    const updateOnEnter = (key) => {
        if (key === 'Enter') {
            saveName();
        }
    };

    return (
        <React.Fragment>
            <div className="watchlist-rename-modal" data-metrics-location="PU">
                <div className="modal-title">Rename Watchlist</div>
                <div>
                    <InputField
                        id="rename-input"
                        name="rename"
                        type="text"
                        required
                        defaultValue={name}
                        onKeyPress={(e) => updateOnEnter(e.key)}
                        getValue={(e) => e.value}
                        validation={isValidName}
                        className="rename-input"
                    />
                </div>
                <div className="action-buttons">
                    <button
                        id="watchlist-cancel-rename-btn"
                        className="cancel-button"
                        type="button"
                        onClick={() => closeModal()}
                    >
                        Cancel
                    </button>
                    <button
                        id="watchlist-save-rename-btn"
                        className={cn('save-button', { disabled })}
                        type="button"
                        onClick={() => saveName()}
                    >
                        Save
                    </button>
                </div>
            </div>
            <style jsx>{styles}</style>
        </React.Fragment>
    );
};

export default WatchlistRename;
